import React, { ReactNode } from 'react';

import { DateTime } from 'luxon';
import { FormattedMessage, IntlShape } from 'react-intl';
import { DefaultTheme } from 'styled-components';

import { CoreUtils, IdEnums, ShortCodeEnums, CoreCommonMessages } from '@nhl/nhl-breakaway-ui';

import { PeriodDescriptor } from '~/core/types';

export const getGameStatusInfo = ({
    gameType,
    gameScheduleState,
    gameState,
    intl,
    periodDescriptor,
    startTimeUTC,
}: {
    gameType: IdEnums.GameType;
    gameScheduleState: ShortCodeEnums.GameScheduleState;
    gameState: ShortCodeEnums.GameState;
    intl: IntlShape;
    periodDescriptor: PeriodDescriptor;
    startTimeUTC: string;
}): ReactNode => {
    if (CoreUtils.isGameLive(gameState)) {
        return CoreUtils.getPeriodDisplayFromDescriptor(intl, periodDescriptor, gameType);
    }
    if (gameScheduleState === ShortCodeEnums.GameScheduleState.toBeDetermined) {
        return (
            <FormattedMessage
                {...CoreCommonMessages.gameScheduleStateDescriptions.abbreviations[
                    ShortCodeEnums.GameScheduleState.toBeDetermined
                ]}
            />
        );
    }
    return DateTime.fromISO(startTimeUTC).toLocaleString({ ...DateTime.TIME_SIMPLE, timeZoneName: 'short' });
};

export const determineGameInfoChipColor = (
    isGameLive: boolean,
    isGameCritical: boolean,
    theme: DefaultTheme
): string => {
    if (isGameLive) {
        return isGameCritical ? theme.Utility.critical : theme.Utility.Opposite.success;
    } else {
        return theme.Surface.tertiary;
    }
};
